// extracted by mini-css-extract-plugin
export default {"cover":"FragComponent_cover__geBWU","main":"FragComponent_main__KMCg2","footer":"FragComponent_footer__mdX5-"};